import { useEffect, useState } from "react";

export const useCachedStorage = (
	key,
	initialValue,
	ttlHours = 48,
	{ allowStale = true } = {},
) => {
	const [value, setValue] = useState(() => {
		try {
			const stored = localStorage.getItem(key);
			if (!stored) return initialValue;

			const parsed = JSON.parse(stored);
			if (!parsed || typeof parsed !== "object" || !("value" in parsed)) {
				return parsed ?? initialValue;
			}

			const { value: storedValue, timestamp } = parsed;
			const now = new Date().getTime();
			const ttlMs = ttlHours * 60 * 60 * 1000;
			const isFresh = !timestamp || now - timestamp < ttlMs;

			if (isFresh || allowStale) {
				return storedValue;
			}
		} catch (error) {
			console.error(`Error reading cached storage key "${key}":`, error);
		}

		return initialValue;
	});

	useEffect(() => {
		try {
			const payload = {
				value,
				timestamp: new Date().getTime(),
			};
			localStorage.setItem(key, JSON.stringify(payload));
		} catch (error) {
			console.error(`Error writing cached storage key "${key}":`, error);
		}
	}, [key, value]);

	return [value, setValue];
};
